import { useState } from "react";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { cn } from "@volca/ui/lib/utils";

interface DocumentFrameProps {
  src: string;
  title: string;
}

/**
 * A PDF in an iframe, held back until it has loaded. The browser's PDF viewer
 * paints its own dark background before the pages, which reads as a black
 * flash; a skeleton the same size covers it until the document is ready.
 */
export const DocumentFrame = ({ src, title }: DocumentFrameProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative h-[60cqh] w-full sm:h-[78cqh]">
      {!isLoaded && (
        <Skeleton className="absolute inset-0 rounded-none" aria-hidden />
      )}
      <iframe
        // Hide the browser's native PDF chrome and fit to width for a
        // cleaner embedded look.
        src={`${src}#toolbar=0&navpanes=0&view=FitH`}
        title={title}
        onLoad={() => setIsLoaded(true)}
        className={cn("h-full w-full border-0 transition-opacity", {
          "opacity-0": !isLoaded,
        })}
      />
    </div>
  );
};
